/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserversModule } from '@angular/cdk/observers';
import { MatRippleModule, MatCommonModule } from '@angular/material/core';
import { MatCheckbox } from './checkbox';
import { MatCheckboxRequiredValidator } from './checkbox-required-validator';
import { A11yModule } from '@angular/cdk/a11y';
export class MatCheckboxModule {
}
MatCheckboxModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, MatRippleModule, MatCommonModule, ObserversModule, A11yModule],
                exports: [MatCheckbox, MatCheckboxRequiredValidator, MatCommonModule],
                declarations: [MatCheckbox, MatCheckboxRequiredValidator],
            },] },
];
/**
 * @nocollapse
 */
MatCheckboxModule.ctorParameters = () => [];
function MatCheckboxModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatCheckboxModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatCheckboxModule.ctorParameters;
}
//# sourceMappingURL=checkbox-module.js.map